// test to replace whitespaces with hyphens
export const cleanPathParam = (url) => {
	return url.replace(/\s/g, '-');
};
